// Les heures d'une feuille de temps se lisent pareil pour le salarié et pour
// la RH : « 16 h 45 », « 30 min », « 8 h », des écarts signés, des jours en clair.

// « 16 h 45 », « 30 min », « 8 h » : des heures qui se lisent comme on les dit.
export const formaterDuree = (valeur, t) => {
  const minutes = Math.round(Math.abs(valeur) * 60);
  const heures = Math.floor(minutes / 60);
  const reste = minutes % 60;
  if (!heures) return t('feuilleTemps.minutes', { minutes: reste });
  if (!reste) return t('feuilleTemps.heuresPleines', { heures });
  return t('feuilleTemps.heuresMinutes', { heures, minutes: String(reste).padStart(2, '0') });
};

// Zéro se lit « 0 h » : « 0 min » ferait croire à une mesure, un tiret à une
// donnée manquante.
export const dureeDuJour = (valeur, t) => (valeur ? formaterDuree(valeur, t) : t('feuilleTemps.heuresPleines', { heures: 0 }));

// Un écart nul ne s'écrit pas : l'appelant ne l'affiche que s'il y en a un.
export const formaterEcart = (valeur, t) => `${valeur > 0 ? '+' : '-'}${formaterDuree(valeur, t)}`;

export const decalerJours = (date, jours) => {
  const repere = new Date(`${date}T00:00:00Z`);
  repere.setUTCDate(repere.getUTCDate() + jours);
  return repere.toISOString().slice(0, 10);
};

const localeDe = (langue) => (langue === 'en' ? 'en-GB' : 'fr-FR');

export const dateLisible = (date, langue) => new Date(`${date}T00:00:00Z`)
  .toLocaleDateString(localeDe(langue), { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

export const jourLisible = (date, langue) => new Date(`${date}T00:00:00Z`)
  .toLocaleDateString(localeDe(langue), { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });

export const moisLisible = (mois, langue) => new Date(`${mois}-01T00:00:00Z`)
  .toLocaleDateString(localeDe(langue), { month: 'long', year: 'numeric', timeZone: 'UTC' });
